import { AnnouncementData } from '@/api/announcements/types';
import Snackbar from '@/components/Snackbar';
import { GridMain } from '@/components/UI/Grid';
import { Constants, statusLabels } from '@/constants/announcements';
import { IconLocalActivityMS } from '@/constants/icons';
import { GlobalContext } from '@/context/global';
import { formatDateMonthName } from '@/helpers';
import { Box } from '@mui/material';
import { useContext } from 'react';

import { Table } from '../Oversight/components/Table';
import { StyledTableCellBody } from '../Oversight/components/Table/styles';
import {
  HeaderContainer,
  InfoBanner,
  NewAnnouncementButton,
  PageSubtitle,
  PageTitle,
  StatusChip,
  TableWrapper,
} from './styles';
import useAnnouncements from './useAnnouncements';

const tableHeadRow = [
  { label: Constants.columnName, key: 'title' },
  { label: Constants.columnCards, key: 'cards_count' },
  { label: Constants.columnCreatedAt, key: 'created_at' },
  { label: Constants.columnPublishedAt, key: 'published_at' },
  { label: Constants.columnViewed, key: 'viewed' },
  { label: Constants.columnCompleted, key: 'completed' },
  { label: Constants.columnStatus, key: 'status' },
] satisfies {
  label: string;
  key: keyof AnnouncementData;
}[];

export function Announcements(): JSX.Element {
  const {
    announcements,
    isLoading,
    page,
    setPage,
    perPage,
    records,
    handleNewAnnouncement,
    handleGoToDetails,
  } = useAnnouncements();

  const { openSnackbar } = useContext(GlobalContext);

  return (
    <GridMain>
      <HeaderContainer>
        <Box>
          <PageTitle>{Constants.title}</PageTitle>
          <PageSubtitle>{Constants.subtitle}</PageSubtitle>
        </Box>
        <NewAnnouncementButton onClick={handleNewAnnouncement}>
          {Constants.newAnnouncement}
        </NewAnnouncementButton>
      </HeaderContainer>

      <InfoBanner>{Constants.onlyOneActive}</InfoBanner>

      <TableWrapper>
        <Table
          data={announcements}
          tableHeadData={tableHeadRow}
          getRowId={(row) => row.id}
          onRowClick={(row) => handleGoToDetails(row.id)}
          emptyTableIcon={IconLocalActivityMS}
          emptyTableDescription={Constants.emptyTable}
          entityLabel={Constants.entityLabel}
          records={records}
          page={page}
          setPage={setPage}
          pageSize={perPage}
          isLoading={isLoading}
          sortableKeys={['status']}
          threeStateSort
          renderRow={(row) => (
            <>
              <StyledTableCellBody>{row.title}</StyledTableCellBody>
              <StyledTableCellBody>{row.cards_count}</StyledTableCellBody>
              <StyledTableCellBody>
                {formatDateMonthName(row.created_at)}
              </StyledTableCellBody>
              <StyledTableCellBody>
                {formatDateMonthName(row.published_at)}
              </StyledTableCellBody>
              <StyledTableCellBody>{row.viewed}</StyledTableCellBody>
              <StyledTableCellBody>{row.completed}</StyledTableCellBody>
              <StyledTableCellBody>
                <StatusChip status={row.status}>
                  {statusLabels[row.status]}
                </StatusChip>
              </StyledTableCellBody>
            </>
          )}
        />
      </TableWrapper>

      {openSnackbar && <Snackbar />}
    </GridMain>
  );
}
